var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('backButton'),(_vm.user)?[_c('div',{domProps:{"innerHTML":_vm._s(
        _vm.$t('Are you sure you want to delete user', {
          user: _vm.user.FirstName + ' ' + _vm.user.LastName,
        })
      )}}),_c('br'),_c('cancelConfirmButtons',{attrs:{"confirmFunction":_vm.deleteUser,"loading":_vm.deleting,"confirmLabel":_vm.$t('Delete')},on:{"goBack":_vm.goBack}})]:(!_vm.$store.getters.error)?[_c('preloader')]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }